import TopCountryFilter from "../../components/filters/TopCountryFilter/TopCountryFilter";
import TopCountryFilterResult from "../../components/filters/TopCountryFilter/TopCountryFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilter } from "../defineLeadsFilter";

import FindTopCountryFilter from "./TopCountryFilter";

// Options come from the always-present country service, so no data source is required.
export const topGeoCountriesDefinition = defineLeadsFilter({
    key: "topGeoCountries",
    apiCategory: leadsFilterApiCategory.topGeoCountries,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Top Country",
    titleKey: { key: "si.lead_gen_filters.group.top_country.name" },

    render: ({ countryService }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.topCountry.tooltip" },
        filter: new FindTopCountryFilter({
            options: countryService.trafficCountriesWithoutWorldwide,
        }),
        filterView: TopCountryFilter,
        filterResultView: TopCountryFilterResult,
    }),
});
